import React, { useState } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import "moment-timezone";
import "./App.css";
import Neo from "./components/Neo";
import Footer from "./components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";
import Slider from "react-slick";
import eartht from "./assets/images/earth-6.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMeteor } from "@fortawesome/free-solid-svg-icons";

function App(button, state) {
  const [neo, setNeo] = useState([]);

  const API_KEY = "wZUGuwlj8fTXgKfXrp1xPILyE1UB27KtYNu659IH";

  const END_DATE = "";

  var today = new Date(),
    date =
      today.getFullYear() +
      "-" +
      ("0" + (today.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + today.getDate()).slice(-2);

  const url = `https://api.nasa.gov/neo/rest/v1/feed?start_date=${date}&end_date=${END_DATE}&api_key=${API_KEY}`;

  const getData = async () => {
    const result = await axios.get(url);
    setNeo(result.data.near_earth_objects[date]);
  };

  return (
    <div className="App container" onLoad={getData}>
      <div className="stars"></div>
      <div className="twinkling"></div>
      <div className="row">
        <div className="col-12">
          <h1 className="Title-Header">Any Asteroids Tonight?</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="Neo">
            <Slider>
              {neo !== [] && neo.map((neo) => <Neo key={uuidv4()} neo={neo} />)}
            </Slider>
          </div>
        </div>
      </div>

      <div id="earth-row" className="row">
        <div className="col-12">
          <div className="Earth">
            <img src={eartht} alt="eartht" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
